document.addEventListener('DOMContentLoaded', () => {
	// Injection styles des formulaires shopify-forms
	const formContainer = document.querySelector('#form-container-ref');
	
	const observer = new MutationObserver((mutationsList, observer) => {
		const form = document.querySelector('form-embed');
		
		if (form) {
			observer.disconnect();
			const shadow = form.shadowRoot;
			
			const sheet = new CSSStyleSheet();
			sheet.insertRule(`
				form {
				  gap: 20px !important;
				}
		  `);
			sheet.insertRule(`
	  			section._formHeader_1nihh_19 {
					display: none;
	  			}
			`);
			
			let maxWidth = "100%";

			if (window.matchMedia("(min-width: 769px)").matches) {
				maxWidth = "75%";
			}

			sheet.insertRule(`
				._inline_stahb_47 ._formContainer_stahb_30 {
					max-width: ${maxWidth};
				}
		  	`);

			sheet.insertRule(`
				._horizontalLayout_nw6va_12 {
					display: flex;
					flex-wrap: wrap;
				}
		  	`);

			sheet.insertRule(`
				._horizontalLayout_nw6va_12 label span {
					white-space: nowrap;
				}
		  	`);

			sheet.insertRule(`
				._formFileInput_ehvsf_1 ._formFileInputFileName_ehvsf_34 span {
					color: white;
				}
		  	`);

			sheet.insertRule(`
				input, textarea, button[type="button"]{
					background-color: #ffffff !important;
					border-radius: 0 !important;
					box-shadow: none !important;
					color: #0F3043 !important;
				}
			`);
			sheet.insertRule(`
				label{
					color: rgba(15, 48, 67, 0.40) !important;
				}
			`);
			sheet.insertRule(`
				p{
					color: rgba(15, 48, 67, 1) !important;
				}
			`);
			sheet.insertRule(`
				button[type="submit"]{
					background-color: rgba(15, 48, 67, 1) !important;
					border-radius: 3px !important;
					width: fit-content;
				}
			`);
			sheet.insertRule(`
				div button[type="button"]{
					background-color: rgba(15, 48, 67, 1) !important;
					border-radius: 3px !important;
					color: rgba(156, 249, 204, 1) !important;
				}
			`);
			sheet.insertRule(`
				div button[type="button"] svg path{
					fill: rgba(156, 249, 204, 1) !important;
				}
			`);
			sheet.insertRule(`
				legend[class*="_radioLegend"], legend[class*="_checkboxLegend"], p[class*="_label"], div[class*="_formFileInput"] p[class*="_textBody"] {
					font-size: 16px;
					font-weight: 600;
					color: #0F3043;
				}
			`);
			sheet.insertRule(`
				label[class*="_checkboxField"] span[class*="_textBody"] {
					font-size: 14px;
					font-weight: 400;
					color: #46636A;
				}
			`);
			sheet.insertRule(`
				form[class*="_formFieldset"] div[class*="_selectContainer"],
				form[class*="_formFieldset"] fieldset[class*="_checkboxFieldSet"],
				form[class*="_formFieldset"] button[class*="_formSubmitButton"],
				form[class*="_formFieldset"] div[class*="_formFileInput"] {
					margin-top: 20px;
				}
			`);
			sheet.insertRule(`
				form[class*="_formFieldset"] div[class*="_formFieldContainer"] textarea {
					aspect-ratio: 1064/287;
				}
			`);
			sheet.insertRule(`
				form[class*="_formFieldset"] button[class*="_formSubmitButton"] {
					font-size: 16px;
					font-weight: 600;
					padding: 25px;
				}
			`);
				
			shadow.adoptedStyleSheets.push(sheet);
			formContainer.classList.add('loaded');
		}
	});
		
	observer.observe(document.body, { childList: true, subtree: true });

	// Shopify Forms (<shopify-forms-embed>) : sous 490px, l'app centre le formulaire dans une grille
	// dont la colonne prend la largeur du contenu. On force la colonne en pleine largeur.
	const formsFullWidthSheet = new CSSStyleSheet();
	formsFullWidthSheet.replaceSync(`
		[class*="_appEmbed_"] > [class*="_container_"] {
			grid-template-columns: minmax(0, 1fr);
		}
	`);

	const applyFormsFullWidth = (embed) => {
		let tries = 0;
		const applySheet = () => {
			if (embed.shadowRoot) {
				if (!embed.shadowRoot.adoptedStyleSheets.includes(formsFullWidthSheet)) {
					embed.shadowRoot.adoptedStyleSheets.push(formsFullWidthSheet);
				}
			} else if (tries++ < 50) {
				requestAnimationFrame(applySheet);
			}
		};
		applySheet();
	};

	// Le composant est inséré par l'app après le chargement de la page
	document.querySelectorAll('shopify-forms-embed').forEach(applyFormsFullWidth);
	new MutationObserver((mutations) => {
		mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
			if (node.nodeType !== 1) return;
			if (node.matches('shopify-forms-embed')) applyFormsFullWidth(node);
			node.querySelectorAll('shopify-forms-embed').forEach(applyFormsFullWidth);
		}));
	}).observe(document.body, { childList: true, subtree: true });

	const headerSearch = document.querySelector('.header__icons .header__search');

	if (headerSearch) {
		const headerSearchDetails = headerSearch.querySelector('details');

		if (window.matchMedia("(min-width: 990px)").matches) {
			headerSearchDetails.open = true;
		}
	}

	const linksMenuColumns = document.querySelectorAll('.multicolumn.multicolumn-menu-style a');

	linksMenuColumns.forEach(link => {
		link.addEventListener('click', (e) => {
			e.preventDefault();
			let blkId = link.dataset.id;

			if (blkId) {
				blkId = blkId.substring(1);

				const blk = document.getElementById(blkId);

				if (blk) {
					const topValue = blk.getBoundingClientRect().top - 100;
					window.scrollTo({
						top: topValue,
						behavior: "smooth",
					});
				}
			}
		});
	});

	const blockBg = document.getElementById('MainContent');
	const menuRef = document.querySelector('.menu-faq__groups');

	if (blockBg && menuRef) {
		let menuRefPositions = menuRef.getBoundingClientRect();
    	let menuRefRight = document.documentElement.clientWidth - menuRefPositions.right;

    	blockBg.style.setProperty("--right-position", menuRefRight + "px");

		window.addEventListener("resize", () => {
			menuRefPositions = menuRef.getBoundingClientRect();
			menuRefRight = document.documentElement.clientWidth - menuRefPositions.right;
			blockBg.style.setProperty("--right-position", menuRefRight + "px");
		});
	}

	// Add to cart sticky on page product
	const stickyBar = document.getElementById("sticky-add-to-cart");
	if(stickyBar === null) return;
	const productPrice = document.querySelector(".price");
	const addToCartButton = document.querySelector(".sticky-add-to-cart-btn");
	const originalAddToCart = document.querySelector(".product-form form [type='submit']");

	function toggleStickyBar() {
		if (!productPrice) return;
		const pricePosition = productPrice.getBoundingClientRect().bottom + window.scrollY;
		if (window.scrollY > pricePosition) {
			stickyBar.classList.add("visible");
		} else {
			stickyBar.classList.remove("visible");
		}
	}

	// Scroll event
	window.addEventListener("scroll", toggleStickyBar);

	// Ajouter au panier
	addToCartButton.addEventListener("click", function () {
		if (originalAddToCart) {
			originalAddToCart.click();
		}
	});

});
	